import {
  IExhibitorsDashboardTranslations,
  IExhibitorTickets,
  IExhibitorExports,
  IExhibitorVisitors,
  IExhibitorSidebar,
  IExhibitorSettingsTranslations,
  IExhibitorProducsTranslations,
  IExhibitorInteractionsTranslations,
  IExhibitorOnboardingTranslations,
  IExhibitorSessions,
  IExhibitorProductInteractions,
  IExhibitorProfile,
} from '@/translations/default/exhibitors';

const dashboard: Partial<IExhibitorsDashboardTranslations> = {
  // leave empty until needed
};

const tickets: Partial<IExhibitorTickets> = {
  // leave empty until needed
};

const exports: Partial<IExhibitorExports> = {
  // leave empty until needed
};

const visitors: Partial<IExhibitorVisitors> = {
  // leave empty until needed
};

const sidebar: Partial<IExhibitorSidebar> = {
  exhibitor_interactions: 'Spontanbewerbungen',
  interactions: 'Kandidaten',
  products: 'Job-Angebote',
  product_interactions: 'Bewerbungen für Jobangebote',
};

const settings: Partial<IExhibitorSettingsTranslations> = {
  // leave empty until needed
};

const products: Partial<IExhibitorProducsTranslations> = {
  title: 'Job-Angebote',
  subtitle: 'Job-Angebote erstellen, bearbeiten und löschen',
  no_products: 'Keine Job-Angebote verfügbar',
  new_product: 'Neues Job-Angebot',
  create_new_product: 'Neues Job-Angebot erstellen',
  edit_product: 'Job-Angebot bearbeiten',
  interactions_exist_cannot_delete:
    'Dieses Job-Angebot hat bereits Bewerber, deshalb kann es nicht gelöscht werden',
  you_have: 'Sie haben noch',
  products_left: 'Job-Angebot.',
  form_not_ready:
    'Das Formular für das Stellenangebot wurde von Ihrem Veranstaltungsmanager noch nicht erstellt. Bitte versuchen Sie es später noch einmal.',
};

const interactions: Partial<IExhibitorInteractionsTranslations> = {
  title: 'Spontanbewerbungen',
  subtitle: 'Bewerbungen überprüfen und Meetings planen',
  noInteractions: 'Dieser Aussteller hat keine Bewerbungen.',
};

const onboarding: Partial<IExhibitorOnboardingTranslations> = {
  // leave empty until needed
};

const sessions: Partial<IExhibitorSessions> = {
  // leave empty until needed
};

const productInteractions: Partial<IExhibitorProductInteractions> = {
  title: 'Bewerbungen für Jobangebote',
  subtitle: 'Bewerbungen überprüfen und Meetings planen',
  product_name: 'Job-Angebot',
  interaction_name: 'Name des Kandidaten',
  application: 'Anwenden',
};

const profile: Partial<IExhibitorProfile> = {
  products: 'Job-Angebote',
};

export default {
  dashboard,
  settings,
  interactions,
  onboarding,
  sidebar,
  sessions,
  products,
  productInteractions,
  exports,
  visitors,
  profile,
  tickets,
};
